import { render, staticRenderFns } from "./new-footer-white.vue?vue&type=template&id=521a7c30&scoped=true"
import script from "./new-footer-white.vue?vue&type=script&lang=js"
export * from "./new-footer-white.vue?vue&type=script&lang=js"
import style0 from "./new-footer-white.vue?vue&type=style&index=0&id=521a7c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521a7c30",
  null
  
)

export default component.exports